import React, { Component } from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { Attachment, ICircle, Search } from "@vitalsource/vstui-icons";
import BookAssignments from "../../../library/icons/BookAssignments";
import { selectors as booksSelectors } from "../../../../../redux/books";
import { selectors as feenySelectors } from "../../../../../redux/feeny";
import { selectors as ancillarySelectors } from "../../../../../redux/ancillaries";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { actions as uiLibraryActions } from "../../../../../redux/ui/library";
import { RoundWhiteButton } from "../../../../components/custom-buttons/white-buttons";
import Badge from "../../../../components/custom-buttons/badge-button";
import { t } from "../../../../core/translate";
import { createThemedComponent } from "@vitalsource/vstui/themes";

const HeroIconContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const OutlinedBadge = styled(
  createThemedComponent(Badge, props => ({
    Button_borderRadius: "100px",
    Button_borderColor_themePrimary: props.theme.vstui.color.white,
    Button_borderColor_themePrimary_hover: props.theme.vstui.color.white,
    Button_borderColor_themePrimary_focus: props.theme.vstui.color.white
  }))
)`
  button {
    padding: 0 16px;
  }
`;

const HeroRoundIcon = styled(RoundWhiteButton)`
  margin: 0px 16px 0px 0px;
`;

class HeroIcons extends Component {
  ancillariesIcon() {
    const { book, openBookPanel, ancillarySummary } = this.props;
    if (ancillarySummary.ancillariesCount) {
      return (
        <HeroRoundIcon
          iconStart={<Attachment />}
          label={t("main-menu.resources", "Resources")}
          onClick={() => openBookPanel("resources", book.title)}
          fullHeight
          size="small"
        />
      );
    }
    return false;
  }

  searchIcon() {
    const { book, openSearchPanel, brand } = this.props;
    if (brand.Search.enabled) {
      return (
        <HeroRoundIcon
          iconStart={<Search />}
          label={t("base.search", "Search")}
          onClick={() => openSearchPanel(book.title)}
          fullHeight
          size="small"
        />
      );
    }
    return false;
  }

  render() {
    const { book, openBookPanel } = this.props;
    return (
      <HeroIconContainer>
        <HeroRoundIcon
          iconStart={<ICircle />}
          label={t("library.details-icon", "View details", {
            bookTitle: book.title
          })}
          onClick={() => openBookPanel("book", book.title)}
          fullHeight
          size="small"
        />
        {this.searchIcon()}
        {this.ancillariesIcon()}
      </HeroIconContainer>
    );
  }
}

const mapStateToProps = (state, props) => ({
  book: booksSelectors.getBookByIsbn(state, props.isbn),
  ancillarySummary: ancillarySelectors.getAncillarySummaryForVbid(
    state,
    props.isbn
  ),
  brand: brandSelectors.getBrand(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  openBookPanel: (tab, title) =>
    dispatch(uiLibraryActions.openBookPanel(props.isbn, tab, title)),
  openSearchPanel: title =>
    dispatch(uiLibraryActions.openSearchPanel(props.isbn, title))
});

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(HeroIcons)
);
